/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const PROVIDER_OPTIONS = ["retell", "pbx"];
const EVENT_TYPE_OPTIONS = ["call.incoming", "call.ended", "call.recording", "call.unknown"];

const WebhookEventFilterPopup = ({
  phoneFilter = "",
  setPhoneFilter = () => {},
  eventTypeFilter = "",
  setEventTypeFilter = () => {},
  providerFilter = "",
  setProviderFilter = () => {},
  fromDate = "",
  setFromDate = () => {},
  toDate = "",
  setToDate = () => {},
  onApply = () => {},
  onReset = () => {},
}) => {
  const { t } = useTranslation();

  // local state — committed to parent only on Apply
  const [localPhone, setLocalPhone] = useState(phoneFilter);
  const [localEventType, setLocalEventType] = useState(eventTypeFilter);
  const [localProvider, setLocalProvider] = useState(providerFilter);
  const [localFromDate, setLocalFromDate] = useState(fromDate);
  const [localToDate, setLocalToDate] = useState(toDate);

  // sync when parent resets
  useEffect(() => {
    setLocalPhone(phoneFilter);
    setLocalEventType(eventTypeFilter);
    setLocalProvider(providerFilter);
    setLocalFromDate(fromDate);
    setLocalToDate(toDate);
  }, [phoneFilter, eventTypeFilter, providerFilter, fromDate, toDate]);

  const handleApply = () => {
    setPhoneFilter(localPhone);
    setEventTypeFilter(localEventType);
    setProviderFilter(localProvider);
    setFromDate(localFromDate);
    setToDate(localToDate);
    onApply({ localPhone, localEventType, localProvider, localFromDate, localToDate });

    // close offcanvas
    const el = document.querySelector("#webhookEventFilter");
    if (el) {
      const instance =
        window.bootstrap?.Offcanvas?.getInstance(el) ||
        new window.bootstrap.Offcanvas(el);
      instance.hide();
    }
  };

  const handleReset = () => {
    setLocalPhone("");
    setLocalEventType("");
    setLocalProvider("");
    setLocalFromDate("");
    setLocalToDate("");
    setPhoneFilter("");
    setEventTypeFilter("");
    setProviderFilter("");
    setFromDate("");
    setToDate("");
    onReset();

    const el = document.querySelector("#webhookEventFilter");
    if (el) {
      const instance =
        window.bootstrap?.Offcanvas?.getInstance(el) ||
        new window.bootstrap.Offcanvas(el);
      instance.hide();
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end custom-offcanvas"
      tabIndex="-1"
      id="webhookEventFilter"
      aria-labelledby="webhookEventFilterLabel"
    >
      <div className="offcanvas-header bg-primary text-white">
        <h5 className="offcanvas-title" id="webhookEventFilterLabel">
          {t("Filter Events")}
        </h5>
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>

      <div className="offcanvas-body">
        <form onSubmit={(e) => e.preventDefault()} className="d-flex flex-column gap-3">
          {/* phone */}
          <div>
            <label className="fw-semibold fs-sm mb-1 d-block">{t("Phone")}</label>
            <input
              type="text"
              className="form-control shadow-none"
              placeholder="+1415..."
              value={localPhone}
              onChange={(e) => setLocalPhone(e.target.value)}
            />
          </div>

          {/* event type */}
          <div>
            <label className="fw-semibold fs-sm mb-1 d-block">{t("Event Type")}</label>
            <select
              className="form-select shadow-none"
              value={localEventType}
              onChange={(e) => setLocalEventType(e.target.value)}
            >
              <option value="">{t("All")}</option>
              {EVENT_TYPE_OPTIONS.map((et) => (
                <option key={et} value={et}>
                  {et}
                </option>
              ))}
            </select>
          </div>

          {/* provider */}
          <div>
            <label className="fw-semibold fs-sm mb-1 d-block">{t("Provider")}</label>
            <select
              className="form-select shadow-none"
              value={localProvider}
              onChange={(e) => setLocalProvider(e.target.value)}
            >
              <option value="">{t("All")}</option>
              {PROVIDER_OPTIONS.map((p) => (
                <option key={p} value={p} className="text-capitalize">
                  {p.charAt(0).toUpperCase() + p.slice(1)}
                </option>
              ))}
            </select>
          </div>

          {/* from date */}
          <div>
            <label className="fw-semibold fs-sm mb-1 d-block">{t("From Date")}</label>
            <input
              type="date"
              className="form-control shadow-none"
              value={localFromDate}
              onChange={(e) => setLocalFromDate(e.target.value)}
            />
          </div>

          {/* to date */}
          <div>
            <label className="fw-semibold fs-sm mb-1 d-block">{t("To Date")}</label>
            <input
              type="date"
              className="form-control shadow-none"
              value={localToDate}
              onChange={(e) => setLocalToDate(e.target.value)}
            />
          </div>
        </form>
      </div>

      <div className="offcanvas-footer bottom-0 start-0 end-0 bg-white p-3 border-top d-flex gap-2">
        <button
          type="button"
          className="btn btn-primary flex-grow-1"
          onClick={handleApply}
        >
          {t("Apply Filter")}
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={handleReset}
        >
          {t("Reset")}
        </button>
      </div>
    </div>
  );
};

export default WebhookEventFilterPopup;
